
const Banner = () => {

    return (
        <div id="rd"></div>
           
    );
}

export default Banner;